import { usePermissions, useTranslate } from "ra-core";
import { Link, useLocation } from "react-router";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub, // GAVION my-calls
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";
import { DraftsNavBadge } from "../ai/drafts/DraftsNavBadge"; // GAVION ai-email
import { MeetingsNavBadge } from "../meetings/MeetingsNavBadge"; // GAVION granola partners
import { RecruitingNavBadge } from "../recruiting/RecruitingNavBadge"; // GAVION recruiting
import { activeNavKey, activeNavSubKey, visibleNavItems } from "./navItems";
import { useActiveDialSession } from "./useActiveDialSession";

export const GavionSidebar = () => {
  const translate = useTranslate();
  const { pathname } = useLocation();
  const active = activeNavKey(pathname);
  const activeSub = activeNavSubKey(pathname); // GAVION my-calls
  const inSession = useActiveDialSession();
  const { permissions } = usePermissions(); // GAVION recruiting: admin-only items
  const { darkModeLogo, title } = useConfigurationContext();
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <Link to="/" className="flex items-center gap-2 px-1 py-2">
          <img
            src={darkModeLogo}
            alt={title}
            className="h-6 group-data-[collapsible=icon]:size-6 group-data-[collapsible=icon]:object-cover group-data-[collapsible=icon]:object-left"
          />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <nav aria-label={translate("gavion.nav.main")}>
              <SidebarMenu>
                {visibleNavItems(permissions === "admin").map((item) => {
                  const label = translate(item.labelKey);
                  const isActive = active === item.key;
                  return (
                    <SidebarMenuItem key={item.key}>
                      <SidebarMenuButton
                        asChild
                        isActive={isActive}
                        tooltip={label}
                        className={
                          item.accent
                            ? "font-bold text-sidebar-primary"
                            : undefined
                        }
                      >
                        <Link
                          to={item.to}
                          aria-current={
                            isActive &&
                            !item.children?.some((c) => c.key === activeSub) // GAVION my-calls
                              ? "page"
                              : undefined
                          }
                        >
                          <item.icon aria-hidden="true" />
                          <span>{label}</span>
                          {item.key === "call" && inSession && (
                            <span
                              role="status"
                              className="ml-auto size-2 rounded-full bg-sidebar-primary"
                              aria-label={translate("gavion.nav.in_session")}
                            />
                          )}
                        </Link>
                      </SidebarMenuButton>
                      {item.badge === "ai_drafts" && <DraftsNavBadge />}
                      {item.badge === "meetings_unmatched" && (
                        <MeetingsNavBadge />
                      )}
                      {item.badge === "job_applications_new" && (
                        <RecruitingNavBadge />
                      )}
                      {/* GAVION my-calls: sub-links (hidden when the sidebar is collapsed to icons) */}
                      {item.children && item.children.length > 0 && (
                        <SidebarMenuSub>
                          {item.children.map((c) => (
                            <SidebarMenuSubItem key={c.key}>
                              <SidebarMenuSubButton
                                asChild
                                isActive={activeSub === c.key}
                              >
                                <Link
                                  to={c.to}
                                  aria-current={
                                    activeSub === c.key ? "page" : undefined
                                  }
                                >
                                  <c.icon aria-hidden="true" />
                                  <span>{translate(c.labelKey)}</span>
                                </Link>
                              </SidebarMenuSubButton>
                            </SidebarMenuSubItem>
                          ))}
                        </SidebarMenuSub>
                      )}
                    </SidebarMenuItem>
                  );
                })}
              </SidebarMenu>
            </nav>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};
